import React, { useState } from 'react';
import { useAuth } from '../context/useAuth';
import { Tabs, Tab, Box } from '@mui/material';
import IntegrationsSettings from './IntegrationsSettings.jsx';
import AppearanceSettings from './AppearanceSettings.jsx';
import GeneralSettings from './GeneralSettings.jsx';
import RelayAgentsSettings from './RelayAgentsSettings.jsx';
import AboutSettings from './AboutSettings.jsx';
import { DynamicIcon } from '../components/icons.jsx';
import { hasPermission } from '../utils/permissions';
import { PERMISSIONS } from '../constants/permissions';


const TenantSettingsPage = ({ token }) => {
    const { user } = useAuth();
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const canManageIntegrations = hasPermission(user, PERMISSIONS.SETTINGS_INTEGRATIONS);
    const canManageRelayAgents = hasPermission(user, PERMISSIONS.RELAY_AGENTS_VIEW);

    return (
        <div className="flex flex-col h-[calc(100vh-64px)] overflow-hidden bg-slate-50 dark:bg-slate-900">
            {/* Header Area with Tabs */}
            <div className="flex-shrink-0 px-6 pt-2 pb-0 bg-white dark:bg-slate-900 border-b border-gray-200 dark:border-slate-800">
                <Box sx={{ width: '100%' }}>
                    <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        aria-label="settings tabs"
                        sx={{
                            minHeight: '48px',
                            '& .MuiTab-root': {
                                minHeight: '48px',
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: '0.95rem',
                                color: 'text.secondary',
                                '&.Mui-selected': { color: 'primary.main' }
                            }
                        }}
                    >
                        <Tab value={0} label="General"       id="tab-0" icon={<DynamicIcon name="Settings" className="w-4 h-4 mb-0 mr-2" />} iconPosition="start" />
                        {canManageIntegrations && <Tab value={1} label="Integrations"  id="tab-1" icon={<DynamicIcon name="Link"     className="w-4 h-4 mb-0 mr-2" />} iconPosition="start" />}
                        <Tab value={2} label="Appearance"    id="tab-2" icon={<DynamicIcon name="Palette"  className="w-4 h-4 mb-0 mr-2" />} iconPosition="start" />
                        {canManageRelayAgents && <Tab value={3} label="Hybrid Agents"  id="tab-3" icon={<DynamicIcon name="Server"   className="w-4 h-4 mb-0 mr-2" />} iconPosition="start" />}
                        <Tab value={4} label="About"          id="tab-4" icon={<DynamicIcon name="Info"     className="w-4 h-4 mb-0 mr-2" />} iconPosition="start" />
                    </Tabs>
                </Box>
            </div>

            {/* Scrollable Content Area */}
            <div className="flex-grow overflow-y-auto p-6">
                <Box role="tabpanel" hidden={activeTab !== 0}>
                    {activeTab === 0 && <GeneralSettings user={user} />}
                </Box>
                {canManageIntegrations && (
                    <Box role="tabpanel" hidden={activeTab !== 1}>
                        {activeTab === 1 && <IntegrationsSettings tenantId={user?.tenantId} token={token} />}
                    </Box>
                )}
                <Box role="tabpanel" hidden={activeTab !== 2}>
                    {activeTab === 2 && <AppearanceSettings token={token} />}
                </Box>
                {canManageRelayAgents && (
                    <Box role="tabpanel" hidden={activeTab !== 3}>
                        {activeTab === 3 && <RelayAgentsSettings tenantId={user?.tenantId} token={token} />}
                    </Box>
                )}
                <Box role="tabpanel" hidden={activeTab !== 4}>
                    {activeTab === 4 && <AboutSettings token={token} />}
                </Box>
            </div>
        </div>
    );
};

export default TenantSettingsPage;
